<template>
  <div>
    <vx-card>
      <vs-table
        :max-items="descriptionItems[0]"
        class="mt-3"
        pagination
        :data="customers.clientDatas"
        description
        search
        v-model="customertbl"
        :description-items="descriptionItems"
        description-title="Registries"
        description-connector="of"
        description-body="Pages"
      >
        <template slot="header">
          <!-- ADD NEW -->
        </template>
        <template slot="thead">
          <vs-th>{{ $t("entity.label.stb_number") }}</vs-th>
          <vs-th>{{ $t("entity.label.customer_number") }}</vs-th>
          <vs-th>{{ $t("entity.label.name") }}</vs-th>
          <vs-th>{{ $t("entity.label.mobile_number") }}</vs-th>
          <vs-th>{{ $t("entity.label.order_number") }}</vs-th>
          <vs-th>{{ $t("entity.label.active_date") }}</vs-th>
          <vs-th>{{ $t("entity.label.expiry_date") }}</vs-th>
          <vs-th>{{ $t("entity.label.balance_amount") }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="index" v-for="(customer, index) in data">
            <vs-td :data="customer.stbId">{{ customer.stbId }}</vs-td>
            <vs-td :data="customer.accountNo">{{ customer.accountNo }}</vs-td>
            <vs-td :data="customer.displayName">{{
              customer.displayName
            }}</vs-td>
            <vs-td :data="customer.phone">{{ customer.phone }}</vs-td>
            <vs-td :data="customer.orderId">{{ customer.orderId }}</vs-td>
            <vs-td :data="getDate(customer.startDate)">{{
              getDate(customer.startDate)
            }}</vs-td>
            <vs-td :data="getDate(customer.endDate)">{{
              getDate(customer.endDate)
            }}</vs-td>
            <vs-td :data="customer.balanceAmount">{{
              customer.balanceAmount
            }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>
import { getEntityCustomers, getEntityById, renewal } from "@/http/entity";
import moment from "moment";
import { mapState } from "vuex";
export default {
  props: ["entityId"],
  data() {
    return {
      descriptionItems: [5, 10, 15],
      customertbl: "",
    };
  },
  methods: {
    async getCustomers() {
      try {
        //const response = await getEntityCustomers(this.entityId);
        this.$store.dispatch("entity/setEntityCustomers", this.entityId);
      } catch (e) {
        this.$toasted.error("something went wrong!");
      }
    },
    async reaload() {
      try {
        const response = await getEntityById(this.entityId);
        await renewal();
        this.$store.dispatch("entity/setEntityDetail", response.data);
      } catch (e) {
        this.$toasted.error("something went wrong!");
      }
    },
    getDate(date) {
      if (date) {
        return moment(date).format(this.formattedDate);
      }
      return null;
    },
  },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    customers() {
      return this.$store.getters["entity/getEntityCustomers"];
    },
  },
  mounted() {
    this.getCustomers();
  },
};
</script>
<style lang="scss" scoped>
</style>